{
  "version": 1,
  "asset_id": "01f827ab-5d54-47ab-bcab-7254fc5e313a",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/01f827ab-5d54-47ab-bcab-7254fc5e313a/sylwia-warsztat-sluchanie.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/01f827ab-5d54-47ab-bcab-7254fc5e313a/sylwia-warsztat-sluchanie.jpg",
  "original_filename": "sylwia-warsztat-sluchanie.jpg",
  "size": 201044,
  "content_type": "image/jpeg",
  "created_at": "2026-08-27T07:45:26Z"
}
